module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-event-item linked-item",
    class: {
      'done-task-event': _vm.event.isDoneTaskEvent(), 'ozzy-task': _vm.event.task.wasOzzyTask()
    }
  }, [_c('div', {
    staticClass: "contact-event-icon small-icon",
    class: _vm.icon_class
  }), _c('div', {
    staticClass: "contact-event-header overflow-ellipsis"
  }, [_c('div', {
    staticClass: "contact-event-title"
  }, [_vm._v(_vm._s(_vm.event.title))]), (_vm.event.flow.name) ? _c('div', {
    staticClass: "contact-event-description"
  }, [_c('div', {
    staticClass: "contact-event-title"
  }, [_vm._v("do ")]), _vm._v(" Fluxo " + _vm._s(_vm.event.flow.name))]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "contact-event-time"
  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))]), _c('div', {
    staticClass: "clear"
  }), (_vm.undone_at) ? _c('div', {
    staticClass: "event-undone-time"
  }, [_vm._v("Marcada como desfeita em " + _vm._s(_vm.undone_at.format('LLL')))]) : _vm._e()]), _c('div', {
    staticClass: "action-bar"
  }, [(_vm.enable_undo) ? _c('div', {
    staticClass: "undo-btn clickable glyphicon glyphicon-repeat",
    on: {
      "click": _vm.undo
    }
  }) : _vm._e(), (_vm.event.task.comment) ? _c('div', {
    ref: "element_id",
    staticClass: "comment-task-action task-comment-icon clickable",
    attrs: {
      "id": _vm.element_id,
      "data-toggle": "tooltip",
      "title": _vm.tooltip_text,
      "data-placement": "left"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "user"
  }, [_c('user-miniature', {
    attrs: {
      "user": _vm.event.task.assigned_to,
      "options": {
        only_picture: true
      }
    }
  })], 1), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10b07fe2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/events/manual_task_event.vue
// module id = 1016
// module chunks = 1